// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"1e89ac4a","90":"658a02e6","118":"ee25d165","320":"640e3efe","447":"2e087267","918":"f5235a9e"}[chunkId] + ".chunk.js";
};